import { getCookie } from './helpers';

/**
 * The Kinesis analytics client factory function that sets up the `trackEvent`,
 * `trackConverion` and/or `trackUser` methods orchestrated by the upstream
 * analytics provider.
 *
 * @kind function
 * @name kinesis
 * @sig {k: v} -> (* -> undefined) -> Boolean -> {k: v}
 * @param {Object} config The analytics config that contains the list of pre-registered events that whitelist all the kinesis events (anything not in those `registeredEvents` will be skipped
 * @param {Function} log An optional logging method that unless it is undefined will always collect the event name and data.
 * @param {Boolean} noPublish Whether or not to send the event to the remote analytics service (or the global script attached to the same app).  This is mainly for debugging, never for production.
 * @returns {Object} An object containing the `trackEvent` and/or `trackConversion` implementations
 */
function kinesis(config = {}, log, noPublish) {
  let isKinesisUnused = false;

  return {
    async trackEvent(eventName, eventData = {}) {
      const registeredEvent = (config.registeredEvents || []).find(({ name }) => name === eventName);
      if (!registeredEvent || isKinesisUnused) {
        return;
      }

      eventData._t = eventData._t || Date.now();
      eventData._n = registeredEvent.caption || eventName;
      eventData._p = eventData._p || getCookie('km_ai');

      if (log) {
        log('[Analytics_Kinesis_Event]', { eventName, eventData });
      }

      if (!noPublish) {
        const response = await fetch(config.url, {
          method: 'post',
          body: JSON.stringify(eventData),
          headers: { 'Content-Type': 'application/json' }
        });

        isKinesisUnused = response.status === 306;
      }
    }
  };
}

export default kinesis;
